import React from 'react'
import DataTable from './DataTable';
import SectionCard from './SectionCard';

const camdata = [
    {
        id: 1,
        sr: 1,
        product: "Fourwrd",
        project: "Indore MMLP",
        period: "Jan-27",
        projectCamRevenue: "6",
        projectCamCostexpense: "6",
        margin: "6",
        percentMargin: "-"
    }
];

const CamNew = () => {
    const columns = [
        { field: "sr", headerName: "#" },
        { field: "product", headerName: "Product" },
        { field: "project", headerName: "Project" },
        { field: "period", headerName: "Period" },
        { field: "projectCamRevenue", headerName: "Project CAM revenue (INR per sqft)" },
        { field: "projectCamCostexpense", headerName: "Project CAM cost/expense (INR per sqft)" },
        { field: "margin", headerName: "Margin" },
        { field: "percentMargin", headerName: "% Margin" },
    ];

    return (
        <>
            <SectionCard title="CAM" description="Monthly Revenue-Cost Margins per sqft for Opeational Efficiency Monitoring" />
            <DataTable columns={columns} data={camdata} />
        </>
    );
}

export default CamNew
